export default __webpack_public_path__ + "static/media/social-media2.63756277.jpg";